var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tips)?_c('tooltip-info',{class:_vm.name,attrs:{"tips":_vm.tips,"data-tea-hover":"create_adgroup_goal_explanation_hover"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }